import minimalContactFragmentRawString from '../MinimalContactFragment.graphql'

export const minimalContactFragmentString = minimalContactFragmentRawString

export type MinimalContactFragment = {
  id: string
  firstName: string
  lastName: string
}

export const isMinimalContactFragment = (
  fragment: any,
): fragment is MinimalContactFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.firstName === 'string' &&
  typeof fragment.lastName === 'string'
